import { AlertTriangle } from '@tamagui/lucide-icons';
import { Row } from '@unistocks/components/layout/flex';
import React from 'react';
import { SizableTextProps, styled, Text } from 'tamagui';

export const ValidationText = styled(Text, {
  name: 'ValidationText',
  color: '$danger',
  fontSize: '$1',
  fontFamily: '$body',
  fontWeight: '$4',
  verticalAlign: 'center',
  flexShrink: 1
});

export const ValidationMessage: React.FC<SizableTextProps> = ({ children }) => {
  return (
    <Row gap={'$2'} alignItems={'center'}>
      <AlertTriangle color={'$danger'} size={'$1'} />
      <ValidationText>{children}</ValidationText>
    </Row>
  );
};
